import SitesList from '@/modules/sites/pages/SitesListPage'
import SiteFormPage from '@/modules/sites/pages/SiteFormPage'

export default [
  {
    name: 'Sites',
    path: '/content/sites/index',
    component: SitesList,
    meta: {
      auth: ['viewProjectItem', 'ContentSites:ReadAccess'],
      title: 'Sites_ListTitle'
    }
  },
  {
    name: 'SiteCreate',
    path: '/content/site/create',
    component: SiteFormPage,
    meta: {
      auth: ['createProjectItem', 'ContentSites:FullAccess'],
      title: 'Site_CreateTitle'
    }
  },
  {
    name: 'SiteUpdate',
    path: '/content/site/update',
    component: SiteFormPage,
    meta: {
      auth: ['updateProjectItem', 'ContentSites:FullAccess'],
      title: 'Site_UpdateTitle'
    }
  },
  {
    name: 'SiteView',
    path: '/content/site/view',
    component: SiteFormPage,
    props: { readonly: true },
    meta: {
      auth: ['viewProjectItem', 'ContentSites:ReadAccess'],
      title: 'Site_ViewTitle'
    }
  },
  {
    name: 'SiteCopy',
    path: '/content/site/copy',
    component: SiteFormPage,
    props: { copy: true },
    meta: {
      auth: ['createProjectItem', 'ContentSites:FullAccess'],
      title: 'Site_CopyTitle'
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/sites/router/index.js